export default function StatCard({ label, value, sub, icon, iconBg, iconColor }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-5 flex-1 min-w-[140px]">
      <div className="flex justify-between items-start">
        <div>
          <div className="text-2xl font-bold leading-tight">{value}</div>
          <div className="text-[13px] text-gray-500 mt-1">{label}</div>
          {sub && <div className="text-[11px] text-gray-400 mt-0.5">{sub}</div>}
        </div>
        <div
          className="w-10 h-10 rounded-[10px] flex items-center justify-center text-[17px]"
          style={{ background: iconBg, color: iconColor }}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
